import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@/modules/common/components/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

function getWidth(length) {
    return 30 + length * 9 + 10;
}

const AutocompleteMultilineField = (props) => {
    const [count, setCount] = useState(0);
    const [maxLength, setMaxLength] = useState(0);

    useEffect(() => {
        let length = 0;
        props.options.forEach((option) => length = (option.length > length) ? option.length : length);
        setMaxLength(length);
    }, [props.options]);

    useEffect(() => {
        let _count = 0;
        props.value.forEach((value) => {
            if (props.options.includes(value)) {
                _count++;
            }
        });
        setCount(_count);
    }, [props.options, props.value]);

    // noinspection JSUnusedLocalSymbols,JSValidateTypes
    return (
        <Autocomplete className={props.className} multiple={true} disableCloseOnSelect={true} clearOnEscape={false}
                      openText='' noOptionsText='Не найдено'
                      options={props.options} value={props.value}
                      renderInput={(params) => {
                          params.InputLabelProps.shrink = true;
                          return (
                              <TextField {...params} label={props.label}/>
                          );
                      }}
                      renderOption={(option, { selected }) => (
                          <>
                              <Checkbox checked={selected} size="small" color="secondary"/>
                              <span className="title">{option}</span>
                          </>
                      )}
                      renderTags={(value, getTagProps) => {
                          let title;
                          const children = [];
                          value.sort();
                          value.forEach((child, id) => {
                              children.push(React.createElement('li', {key: id}, child.toString()));
                          });
                          title = React.createElement('ul', null, children);
                          return (count)
                              ? <Tooltip title={title} arrow={true}>
                                  <Chip label={count.toString()} size="small"/>
                              </Tooltip>
                              : null;
                      }}
                      onChange={(event, value, reason) => {
                          // noinspection JSUnresolvedVariable
                          if (event.key !== 'Backspace') {
                              let _value = [...value];
                              _value = _value.filter((v) => props.options.includes(v));
                              props.setValue(_value);
                          }
                      }}
                      ListboxProps={{style: {minWidth: getWidth(maxLength)}}}
        />
    );
};

AutocompleteMultilineField.propTypes = {
    className: PropTypes.string,
    options: PropTypes.array.isRequired,
    value: PropTypes.array.isRequired,
    setValue: PropTypes.func.isRequired,
};

AutocompleteMultilineField.defaultProps = {
    className: '',
};

export default AutocompleteMultilineField;
